<template>
    <div class="row">
        <div class="col-md-4">
            <span v-if="paginate_data._infos._total">ทั้งหมด {{paginate_data._infos._total}} รายการ</span>
        </div>
        <div class="col-md-8" v-if="paginate_data._infos._has_pages">
            <nav aria-label="Page navigation">
                <ul class="pagination float-right" style="cursor:pointer">
                    <li class="page-item" v-if="paginate_data._infos._current_page>1"><a class="page-link" @click="paginateItemClick(1)">&lt;&lt;</a></li>                    
                    <li class="page-item" v-if="paginate_data._infos._current_page>1"><a class="page-link" @click="paginateItemClick((paginate_data._infos._current_page-1))">&lt;</a></li>
                    <li class="page-item" v-for="page in paginate_data._infos._url_range" v-bind:key="page[0]" @click="paginateItemClick(page[0])">
                        <span class="page-link" > 
                            <strong class="text text-primary" v-if="paginate_data._infos._current_page==page[0]">{{page[0]}}</strong> 
                            <span v-else>{{page[0]}}</span>
                        </span>
                    </li>
                    <li class="page-item" v-if="paginate_data._infos._current_page<paginate_data._infos._last_page"><a class="page-link" @click="paginateItemClick((paginate_data._infos._current_page+1))">&gt;</a></li>
                    <li class="page-item" v-if="paginate_data._infos._current_page<paginate_data._infos._last_page"><a class="page-link" @click="paginateItemClick((paginate_data._infos._last_page))">&gt;&gt;</a></li>
                </ul>
            </nav>
        </div>
    </div>
</template>
<script>
export default {    
        props:{
            paginate_data:{},      
        },
        data() {
            return {
                //paginate_data:{}    
            }
        },
        mounted() {
            //console.log('Component mounted.')            
            //console.log(0,this.paginate_data);
        },
        created(){
            //console.log(this.paginate_data);
            //console.log(1,this.paginate_data);
        },
        methods:{          
            paginateItemClick(page){
                //alert(page);
                this.$emit('paginateItemClick', page);
            }
        },        
    
}
</script>